/** Якоря общих компонентов: ставятся внутри самих компонентов и работают во всех модулях */
export const SHARED_ANCHORS = {
  ear: {
    tasks: 'entity.ear.tasks',
    chat: 'entity.ear.chat',
    document: 'entity.ear.document',
    reports: 'entity.ear.reports',
    link: 'entity.ear.link',
    onboarding: 'entity.ear.onboarding',
  },
  toolbar: {
    reports: 'toolbar.reports',
    onboarding: 'toolbar.onboarding',
  },
  taskCard: {
    performer: 'task.card.performer',
    deadline: 'task.card.deadline',
    checklist: 'task.card.checklist',
    subtask: 'task.card.subtask',
    observers: 'task.card.observers',
    menu: 'task.card.menu',
    statusActions: 'task.card.statusActions',
  },
  demoChat: 'entity.demoChat',
  /** Строка «Поиск и фильтр» (`UniversalSearchFilter`) и её панель */
  searchFilter: {
    field: 'searchFilter.field',
    toggle: 'searchFilter.toggle',
    presets: 'searchFilter.presets',
    words: 'searchFilter.words',
    add: 'searchFilter.add',
    footer: 'searchFilter.footer',
    chips: 'searchFilter.chips',
  },
} as const
